import styled from 'styled-components'

export const H3 = styled.h3`
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  color: ${({ theme }) => theme.palette.gray[800]};
`
